// FIXME: Update this file to be type safe and remove this and next line
// @ts-strict-ignore
export class VerifyBankRequest {
  amount1: number;
  amount2: number;
}
